// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"48":"ba4cd649","104":"e4c3470f","210":"a06dc5b3","404":"a06dc5b3","453":"ba4cd649","589":"4c896d20","746":"ba4cd649","837":"e4c3470f","980":"ba4cd649"}[chunkId] + ".chunk.css";
};